export const propMap = {
  size: {low: ['medium', 'large'], medium: ['small', 'medium', 'large']},
};
export const defaultMap = {
  size: {low: 'medium', medium: 'medium'},
};
